import React, { useState } from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Paper,
  TextField,
  Box,
  Typography,
  Divider,
  Grid,
} from "@mui/material";
import { isMobile } from "react-device-detect";

const ClearanceCertificateForm = ({ clearanceCertificateData }) => {
  const columns = [
    { field: "subscriberCode", headerName: "رمز الاشتراك", flex: 1 },
    { field: "taxType", headerName: "نوع الضريبة", flex: 1 },
    { field: "parcelNumber", headerName: "كود الضريبة", flex: 1 },
    { field: "location", headerName: "الموقع", flex: 1 },
    { field: "beneficiaryType", headerName: "نوع المستفيد", flex: 1 },
  ];

  return (
    <>
      <Box
        sx={{
          background: "#fff",
          fontWeight: "bold",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          py: 1.5,
          px: 3,
          width: isMobile ? "100%" : 300,
          borderRadius: "8px",
          border: "2px solid",
          borderColor: "primary.main",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold", color: "primary.main" }}>
          بيان الذمة
        </Typography>
      </Box>
      <Paper
        elevation={1}
        sx={{ 
          p: 3, 
          borderRadius: "12px",
          border: "1px solid #e0e0e0"
        }}
      >
        <Grid spacing={3} container>
        <Grid item md={12} sm={12} xs={12}>
          <TableContainer component={Paper}>
            <Box p={2} sx={{ direction: "rtl" }}>
              <Table>
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.field}
                        align="center"
                        style={{ textAlign: "center" }}
                      >
                        {column.headerName}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {clearanceCertificateData.map((item) => (
                    <TableRow key={item.subscriberNumber} selected={true} hover>
                      <TableCell align="center">
                        {item.subscriberCode}
                      </TableCell>
                      <TableCell align="center">
                        {item?.serviceType?.name}
                      </TableCell>
                      <TableCell align="center">{item.taxType}</TableCell>
                      <TableCell align="center">{item.location}</TableCell>
                      <TableCell align="center">
                        {item.beneficiaryType?.name}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </TableContainer>
        </Grid>
      </Grid>
      </Paper>

      <Divider />
    </>
  );
};

export default ClearanceCertificateForm;
